<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-content">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Process</label>
                  <select2 v-model="process_id" :options="processOptions"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Server</label>
                  <select2 v-model="server_id" :options="serverOptions"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12">
        <div class="card card-calendar">
          <div class="card-content">
            <div v-if="!process_id || !server_id">
              <p><em>Please choose a grab job and a server</em></p>
            </div>
            <div v-else>
              <log-tabs :process_id="process_id" :server_id="server_id" :threads="threadOptions"/>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import LogTabs from "./Logbook/LogTabs";

export default {
  components: {LogTabs},
  async mounted () {
    await this.processFetchList();
    await this.serverFetchList();
  },
  watch: {
    process_id: async function (processId) {
      if (processId) {
        const process = this.processById()(processId);
        if (process && !process.statsServer) {
          await this.processFetchById(processId);
        }
        await this.logbookFetchList(processId);
        this.updateServerOptions();
      }
    }
  },
  computed: {
    ...mapGetters(['inactiveProcesses']),
    processOptions: function () {
      let options = [];
      this.inactiveProcesses.forEach(function (process) {
        options.push({id: process.id, text: "Grab Job from " + process.created_at});
      });
      return options;
    },
    threadOptions: function () {
      let options = [1];
      const serverId = this.server_id;
      const threadData = this.threadCounts.find(server => server.id === serverId);
      if (threadData && threadData.threads) {
        options = threadData.threads;
      }
      return options;
    }
  },
  data: function () {
    return {
      threads: [],
      serverOptions: [],
      threadCounts: [],
      process_id: null,
      server_id: null
    };
  },
  methods: {
    ...mapActions(['logbookFetchList', 'processFetchList', 'processFetchById', 'serverFetchList']),
    ...mapGetters(['processById', 'serverById']),
    updateServerOptions: function () {
      let options = [];
      let threads = [];
      if (this.process_id) {
        const process = this.processById()(this.process_id);
        if (process && process.statsServer) {
          process.statsServer.forEach((stats) => {
            const server = this.serverById()(stats.server_id)
            const name = !!server ? server.hostname : stats.server_id;
            const threadCount = Array.from({length: stats.threadCount}, (_, i) => i + 1);
            threads.push({id: stats.server_id, threads: threadCount})
            options.push({id: stats.server_id, text: name});
          });
        }
      }
      this.serverOptions = options;
      this.threadCounts = threads;
    },
  }
}
</script>
<style>
.select2 {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Logbook.vue